module.exports = __webpack_public_path__ + "img/icon_search_color.aa067d2f.svg";